/* eslint-disable import/no-anonymous-default-export */
import LoginRoute from "pages/Login/route";

export default [LoginRoute];
